import { useDashboard } from "MyDashboards/api/useDashboards.hook";
import useDashboardEditor from "MyDashboards/state/editor";
import { DashboardOpenMode } from "MyDashboards/state/types";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import Loader from "qpr-base/ui/components/Loader";
import React, { FunctionComponent, useState } from "react";
import { useTranslation } from "react-i18next";
import SlideView from "../../components/SlideView/SlideView";
import SlidesMenu from "../../components/SlidesMenu/SlidesMenu";
import useDashboardStyles from "../themes";

interface CreateDashboardProps {}

const ViewDashboard: FunctionComponent<CreateDashboardProps> = () => {
  const classes = useDashboardStyles()();
  const ctx = useAppContext();
  const load = useDashboardEditor((e) =>
    ctx.page === "editslidetemplatedashboard"
      ? e.loadSlideTemplate
      : e.loadDashboard
  );
  const isLoading = useDashboardEditor((e) => e.isLoading);
  const editorWidth = useDashboardEditor((e) => e.editorWidth);
  const [openMode, setOpenMode] = useState<DashboardOpenMode>(
    DashboardOpenMode.view
  );
  const { data } = useDashboard(ctx.elementId);
  const { i18n } = useTranslation();
  React.useEffect(() => {
    i18n.changeLanguage(ctx.language);
  }, [data, ctx.language]);

  React.useEffect(() => {
    if (ctx.elementId) {
      load(ctx.elementId, editorWidth);
    }
  }, [ctx.elementId, load]);

  React.useEffect(() => {
    switch (ctx.page) {
      case "editslidetemplatedashboard":
      case "editdashboard":
        setOpenMode(DashboardOpenMode.edit);
        break;
      case "viewdashboard":
        setOpenMode(DashboardOpenMode.view);
        break;
      default:
        setOpenMode(DashboardOpenMode.view);
    }
  }, []);

  return (
    <div className={classes.page}>
      <div className={classes.slidesMenu}>
        <SlidesMenu openMode={openMode} />
      </div>
      <div className={classes.slideView}>
        {isLoading ? <Loader /> : <SlideView openMode={openMode} />}
      </div>
    </div>
  );
};

export default ViewDashboard;
